import React from 'react';
import { ApplicationShell } from './helpers/ApplicationShell';
import { AppLayout } from './helpers/AppLayout';
import {
  APP_CONTAINER_BASE_URL,
  PROGRAM_ACCOUNTS,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import {
  AuthContext,
  initialAuthContext,
} from 'src/state/providers/AuthProvider';
import {
  AUTH_ATTRIBUTE,
  isAnonymousUser,
} from 'src/state/providers/helpers/AuthAttributeHelper';

/**
 * Logged in CPR Customer Facing Widget
 */
export const PaymentServicesComplaintWidget = () => {
  return (
    <AuthContext.Provider
      value={{
        ...initialAuthContext,
        accountAttributes: [
          {
            id: PROGRAM_ACCOUNTS.PAYMENTS_SERVICES_COMPLAINT,
            type: 'LENS-UMS-Account',
            attributes: {
              accountName: 'Payments Services Complaints',
              domain: 'NA',
              country: 'NA',
              role: 'Complainant',
            },
          },
        ],
        preferredAccountId: PROGRAM_ACCOUNTS.PAYMENTS_SERVICES_COMPLAINT,
        clientId: UI_CLIENTS.RegulatorCentral,
        customerId: AUTH_ATTRIBUTE.customerId || '',
        customerFullName: AUTH_ATTRIBUTE.customerName || '',
        emailId: AUTH_ATTRIBUTE.emailId || '',
        appContainerBaseUrl: APP_CONTAINER_BASE_URL.PAYMENTS_SERVICES_COMPLAINT,
        isAnonymousUser: isAnonymousUser,
      }}
    >
      <ApplicationShell>
        <AppLayout />
      </ApplicationShell>
    </AuthContext.Provider>
  );
};
